import SecuritizationPoolValueService from '@/lib/abi/SecuritizationPoolValueService.json';
import { configService } from '@/services/config/config.service';
import { getMulticaller } from '@/dependencies/Multicaller';
import moment from 'moment';
import _ from 'lodash';
import { Multicaller } from '@/services/multicalls/multicaller';

export class UPoolMulticaller {
  constructor(
    private readonly MulticallerClass = getMulticaller(),
    private readonly securitizationPoolValueService = configService.network
      .addresses.untangled?.securitizationPoolValueService || ''
  ) {}

  public async fetchPoolValues(pools: any[]) {
    const result = {};
    const multicaller = new this.MulticallerClass();

    pools.forEach(pool => {
      multicaller
        .call({
          key: `${pool.pool.id}.getCashBalance`,
          address: this.securitizationPoolValueService,
          function: 'getCashBalance',
          abi: SecuritizationPoolValueService.abi,
          params: [pool.pool.poolContractAddress],
        })
        .call({
          key: `${pool.pool.id}.getExpectedAssetsValue`,
          address: this.securitizationPoolValueService,
          function: 'getExpectedAssetsValue',
          abi: SecuritizationPoolValueService.abi,
          params: [pool.pool.poolContractAddress],
        });
    });

    return await multicaller.execute(result);
  }

  public async fetchNetAssetValue(
    poolAddress: string,
    days: number,
    ages: number,
    decimals = 6
  ): Promise<[string, number][]> {
    const promises = _.chain(ages)
      .times()
      .map(async i => {
        const unix = moment().subtract(i, 'days').unix();

        const multicaller = new Multicaller();
        multicaller.call({
          key: String(unix),
          address: this.securitizationPoolValueService,
          function: 'getExpectedAssetsValue',
          abi: SecuritizationPoolValueService.abi,
          params: [poolAddress],
        });

        return multicaller.execute();
      })
      .value();
    const res = await Promise.allSettled(promises);

    const data = _.chain(res)
      .flatMap(o => (o.status === 'fulfilled' ? _.toPairs(o.value) : []))
      .map(([date, value]) => {
        const unix = moment.unix(+date);

        return [
          unix.format('YYYY/MM/DD'),
          _.round(+(value as any).toString() / 10 ** decimals, decimals),
        ] as [string, number];
      })
      .value();

    if (_.every(data, ([, value]) => !value)) {
      return [];
    }

    if (data.length < 30) {
      const padding = _.times(30 - data.length, i => {
        const offset = i + data.length;

        const date = moment().subtract(offset, 'days').format('YYYY/MM/DD');

        return [date, 0] as [string, number];
      });

      console.log({ padding, data });

      return padding.concat(data);
    }

    return data;
  }
}
